/**
 * «Algo de lo que cuenta el aviso de Configuración acaba de cambiar».
 *
 * El aviso —la pastilla de cada tarjeta y el «!» del menú— se pedía una vez al
 * abrir el proyecto y no se volvía a preguntar: se completaban los datos del
 * negocio y seguía diciendo que faltaban nueve hasta recargar la página.
 *
 * Lo avisan las funciones de `api.ts` que guardan algo de lo que entra en la
 * cuenta —datos del negocio, políticas, región, ofertas—, y no cada pantalla:
 * así ninguna que se añada mañana puede olvidarse de hacerlo. Aparte de
 * `configAttention.ts` porque éste importa de `api.ts`, y al revés sería un
 * ciclo.
 */
const EVENT = 'veltica:config-attention-changed'

export function notifyConfigAttentionChanged(projectId: string): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent<string>(EVENT, { detail: projectId }))
}

/** Devuelve la función para dejar de escuchar. */
export function onConfigAttentionChanged(listener: (projectId: string) => void): () => void {
  if (typeof window === 'undefined') return () => {}
  const handler = (event: Event) => listener((event as CustomEvent<string>).detail)
  window.addEventListener(EVENT, handler)
  return () => window.removeEventListener(EVENT, handler)
}
